import React, { Component } from 'react';

class EirValidImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false
    };

    this.handleError = this.handleError.bind(this);
  }

  handleError() {
    if (this.props.fallbackSrc) {
      this.setState({
        invalidSrc: this.props.src
      });
    }
  }

  render() {
    // console.log('this.props.src>>',this.props.src);
    return (
      <img className={this.props.className} src={(this.state.invalidSrc == this.props.src ? this.props.fallbackSrc : this.props.src)} onError={this.handleError}/>
    );
  }
}

export default EirValidImage;
